import React from 'react';

import Divider from '../forms/Divider';
import TermsContainer from '../../../consumer/shared/TermsContainer';
import TermsNav from './TermsNav';

const PrivacyPolicyContainer = () => (
  <React.Fragment>
    <TermsNav />
    <Divider />
    <TermsContainer termsType="privacy" />
  </React.Fragment>
);

export default PrivacyPolicyContainer;
